import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AutoCreateLider = () => {
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [nivelId, setNivelId] = useState(""); // 🔹 Nuevo estado para el nivel seleccionado
  const [niveles, setNiveles] = useState([]); // 🔹 Lista de niveles
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  //  Obtener la lista de niveles al cargar la página
  useEffect(() => {
    const fetchNiveles = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/Lider/ListarNiveles`);
        const data = await response.json();
        setNiveles(data);
      } catch (error) {
        console.error("❌ Error al obtener niveles:", error);
      }
    };
    fetchNiveles();
  }, []);

  //  Registrar líder
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/Lider/AutoCreate?nombre=${encodeURIComponent(
          nombre
        )}&telefono=${encodeURIComponent(telefono)}&nivelId=${nivelId}`,
        {
          method: "POST",
          headers: { Accept: "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${await response.text()}`);
      }

      //  Notificación de éxito en la esquina superior derecha
      toast.success("Líder registrado correctamente.", {
        position: "top-right",
        autoClose: 3000, // Se cierra en 3 segundos
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#081b29", // Azul
          color: "#FFFFFF", // Texto blanco
          fontWeight: "bold",
          borderRadius: "8px",
        },
      });

      // 🔹 Limpiar campos
      setNombre("");
      setTelefono("");
      setNivelId("");

    } catch (error) {
      console.error(" Error en la solicitud:", error);

      // Notificación de error
      // PENDIENTE REVISAR CUANDO SE UTILIZA
      toast.error(` Este líder ya ha sido registrado`, { //: ${error.message}
        position: "top-right",
        autoClose: 5000, // Duración más larga para errores
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#081b29",
          color: "#FFFFFF",
          fontWeight: "bold",
          borderRadius: "8px",
        },
      });

      setShowModal(true);
    }

    setLoading(false);
  };


  return (
    <div className="wrapper">
      <div className="form-box">
        <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
        <h2>Registrar Líder</h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4 text-black">
          <div>
            <label className="block text-white">Nombre:</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label className="block text-white">Teléfono (sin +52):</label>
            <input
              type="text"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              className="w-full p-2 border rounded"
              required
              pattern="\d{10}"
              title="Debe contener exactamente 10 dígitos."
            />
          </div>

          {/* 🔹 Seleccionar nivel */}
          <div>
            <label className="block text-white">Nivel:</label>
            <select
              className="w-full p-2 border rounded bg-gray-800 text-white"
              value={nivelId}
              onChange={(e) => setNivelId(e.target.value)}
              required
            >
              <option value="">-- Seleccionar Nivel --</option>
              {niveles.map((nivel) => (
                <option key={nivel.id} value={nivel.id}>
                  ({nivel.id}) {nivel.descripcion}
                </option>
              ))}
            </select>
          </div>

          {/* 🔹 Botón Registrar */}
          <button type="submit" className="btn" disabled={loading}>
            {loading ? "Registrando..." : "Registrar"}
          </button>
        </form>

        {/* 🔹 Mensajes */}
        {mensaje && (
          <p className={`mt-4 text-center ${mensaje.includes("✅") ? "text-green-600" : "text-red-600"}`}>
            {mensaje}
          </p>
        )}

        {/* 🔹 Botón Volver */}
        <button className="btn" onClick={() => navigate("/admin/menu")}>
          Regresar al Menú
        </button>
      </div>

      {/* 🔹 Modal de Error */}
      {/*
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h3 className="text-lg font-semibold text-red-600">
              Este número ya ha sido registrado
            </h3>
            <p className="mt-2">Este número ya ha sido registrado.</p>
            <button
              className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
      */}


    </div>
  );
};

export default AutoCreateLider;
